const MAX_HISTORY = 60;
export class DeckUndoStack {
    past = [];
    future = [];
    reset(deck) {
        this.past = [structuredClone(deck)];
        this.future = [];
    }
    push(deck) {
        const snapshot = structuredClone(deck);
        const top = this.past[this.past.length - 1];
        if (top && JSON.stringify(top) === JSON.stringify(snapshot))
            return;
        this.past.push(snapshot);
        if (this.past.length > MAX_HISTORY)
            this.past.shift();
        this.future = [];
    }
    undo(current) {
        if (this.past.length < 2)
            return null;
        const popped = this.past.pop();
        this.future.push(structuredClone(current));
        return structuredClone(this.past[this.past.length - 1]);
    }
    redo() {
        const next = this.future.pop();
        return next ? structuredClone(next) : null;
    }
    canUndo() {
        return this.past.length > 1;
    }
    canRedo() {
        return this.future.length > 0;
    }
}
